import { Testimonial, TestimonialPaginatedResponse } from "@/types";
import {
  GetAllStudioResponse,
  SocialProofAsset,
  SocialProofAssetQuery,
  TestimonialQuery,
} from "./types";
import { httpClient } from "@/lib/http-client";

export const fetchTestimonial = async (filters: TestimonialQuery) => {
  const queryParams = new URLSearchParams();
  const { sortCriterion, ...others } = filters;

  Object.entries({ ...sortCriterion, ...others }).forEach(([key, value]) => {
    if (typeof value === "boolean" || !!value) {
      if (Array.isArray(value)) {
        value.forEach((v) => queryParams.append(key, v));
      } else {
        queryParams.append(key, value.toString());
      }
    }
  });

  const response = await httpClient.get<TestimonialPaginatedResponse>(
    `/testimonials?${queryParams.toString()}`,
  );

  return response.data;
};

export const fetchTestimonialById = async (id: string) => {
  const response = await httpClient.get<Testimonial>(`/testimonials/${id}`);

  return response;
};

export const getSocialProofAssets = async (query: SocialProofAssetQuery) => {
  const params = new URLSearchParams();

  if (query.projectId) params.append("projectId", query.projectId);
  if (query.search) params.append("search", query.search);
  if (query.sort) params.append("sort", query.sort);
  if (query.order) params.append("order", query.order);
  if (query.tags?.length)
    query.tags.forEach((tag) => params.append("tags", tag));
  if (query.rating) params.append("rating", query.rating.toString());
  if (query.type) params.append("type", query.type);
  if (query.category) params.append("category", query.category);
  if (query.limit) params.append("limit", query.limit.toString());
  if (query.page) params.append("page", query.page.toString());

  const response = await httpClient.get<GetAllStudioResponse>(
    `/social-proof?${params.toString()}`,
  );

  return response;
};

export async function getSocialProofAssetById<T>({
  id,
  refId,
}: {
  id?: string;
  refId?: string;
}) {
  const params = new URLSearchParams();

  if (id) params.append("id", id);
  if (refId) params.append("refId", refId);

  const response = await httpClient.get<SocialProofAsset<T>>(
    `/social-proof?${params.toString()}`,
  );

  return response;
}
